var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { addBook, createBook } from "@/05-models/book";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { PopupButton, PopupInput, PopupTextarea, PopupWindow } from "@/06-shared/ui/popups";
import styles from "./index.module.css";
export const CreateBook = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [id, setId] = useState("");
    const [title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [genre, setGenre] = useState("");
    const [description, setDescription] = useState("");
    const showError = useErrorNotify();
    const reset = () => {
        setId("");
        setTitle("");
        setAuthor("");
        setGenre("");
        setDescription("");
    };
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        const bookId = Number(id);
        if (!Number.isInteger(bookId) || bookId <= 0) {
            showError("ID книги должен быть положительным целым числом");
            return;
        }
        if (!title.trim() || !author.trim() || !genre.trim() || !description.trim()) {
            showError("Заполните все поля книги");
            return;
        }
        try {
            const book = yield createBook({
                id: bookId,
                title: title.trim(),
                author: author.trim(),
                genre: genre.trim(),
                description: description.trim(),
            });
            addBook(book);
            reset();
            setIsOpen(false);
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx("button", { className: styles.openButton, onClick: () => setIsOpen(true), children: "[+]" }), isOpen && (_jsxs(PopupWindow, { name: "\u041D\u043E\u0432\u0430\u044F \u043A\u043D\u0438\u0433\u0430", onClose: () => setIsOpen(false), children: [_jsx(PopupInput, { name: "ID", value: id, setInput: setId, autoFocus: true }), _jsx(PopupInput, { name: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", value: title, setInput: setTitle }), _jsx(PopupInput, { name: "\u0410\u0432\u0442\u043E\u0440", value: author, setInput: setAuthor }), _jsx(PopupInput, { name: "\u0416\u0430\u043D\u0440", value: genre, setInput: setGenre }), _jsx(PopupTextarea, { name: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", value: description, setInput: setDescription }), _jsx(PopupButton, { name: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C", onClick: submit })] }))] }));
};
